
  import { formatDistanceStrict } from "date-fns"

  const HOUR = 3_600_000

  // Tokens date-fns asks a locale for, in the shortest form: `3d`, `4mo`. Only what a strict
  // distance can produce, so no weeks and no seconds.
  const SHORT = { xMinutes: "m", xHours: "h", xDays: "d", xMonths: "mo", xYears: "y" }
  const compactLocale = { formatDistance: (token, count) => `${count}${SHORT[token]}` }

  // Whole hours, or whole minutes inside the last hour, until two days; past that the unit a
  // person would reach for, rounded to the nearest like the React portal does.
  const distance = (ms, compact) => {
    const options = ms < 48 * HOUR
      ? { unit: ms < HOUR ? "minute" : "hour", roundingMethod: "floor" }
      : { roundingMethod: "round" }
    return formatDistanceStrict(ms, 0, compact ? { ...options, locale: compactLocale } : options)
  }

  // `suffix` is the word after the distance, `left` or `overdue`; a compact distance reads the
  // same either way, so only the long form adds `left`.
  const phrase = (ms, compact, suffix) => {
    if (ms < 60_000) { return "Due now" }
    const text = distance(ms, compact)
    return compact && suffix === "left" ? text : `${text} ${suffix}`
  }

  const format = (remaining, { expired, compact }) => {
    const isCompact = compact !== undefined
    if (remaining > 0) { return phrase(remaining, isCompact, "left") }
    return expired || phrase(-remaining, isCompact, "overdue")
  }

  export default {
    mounted() { this.start() },
    updated() {
      const until = Date.parse(this.el.dataset.until)
      const moved = until !== this.until || this.el.dataset.expired !== this.expired
      if (moved) { this.start() } else { this.tick() }
    },
    destroyed() { clearInterval(this.timer) },
    start() {
      clearInterval(this.timer)
      this.until = Date.parse(this.el.dataset.until)
      this.expired = this.el.dataset.expired
      if (isNaN(this.until)) { return }
      this.timer = setInterval(() => this.tick(), 30_000)
      this.tick()
    },
    tick() {
      const remaining = this.until - Date.now()
      const expired = this.el.dataset.expired
      this.setText(format(remaining, this.el.dataset))
      const past = remaining <= 0 && !expired
      this.el.classList.toggle("text-danger-700", past)
      this.el.classList.toggle("dark:text-danger-400", past)
      if (remaining <= 0 && expired) { clearInterval(this.timer) }
    },
    setText(next) {
      if (next !== this.el.textContent) { this.el.textContent = next }
    },
  }
